import { render, staticRenderFns } from "./JournalSystem.vue?vue&type=template&id=6ca73895"
import script from "./JournalSystem.vue?vue&type=script&lang=js"
export * from "./JournalSystem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports